var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function AlignCenter2IconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 5V2.99865C13 2.44711 12.5561 2 12 2C11.4477 2 11 2.44577 11 2.99865V5H2.99865C2.44711 5 2 5.45098 2 6.00427V9.99574C2 10.5504 2.44577 11 2.99865 11H11V13H7.00247C6.44882 13 6 13.451 6 14.0043V17.9957C6 18.5504 6.44851 19 7.00247 19H11V21.0014C11 21.5529 11.4439 22 12 22C12.5523 22 13 21.5542 13 21.0014V19H16.9975C17.5512 19 18 18.549 18 17.9957V14.0043C18 13.4496 17.5515 13 16.9975 13H13V11H21.0014C21.5529 11 22 10.549 22 9.99574V6.00427C22 5.44963 21.5542 5 21.0014 5H13ZM13 7H20V9H13V7ZM11 9H4V7H11V9ZM16 15V17H13V15H16ZM11 15V17H8V15H11Z", fill: "" })));
}
export var AlignCenter2Icon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: AlignCenter2IconInner }, props))); };
//# sourceMappingURL=AlignCenter2Icon.js.map